import preparedReducer from './reducer';
import {
  requestIncidentReportFields,
  updateIncidentReportFields,
  deleteIncidentReportField,
  requestIncidentReportFieldResults,
  addField,
  setUserType,
  updateBuilderFields,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'incidentReportFields';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestIncidentReportFields,
  updateIncidentReportFields,
  deleteIncidentReportField,
  requestIncidentReportFieldResults,
  addField,
  setUserType,
  updateBuilderFields,
};
